import { render, staticRenderFns } from "./MaleTutorial.vue?vue&type=template&id=3bb2bfa7&scoped=true"
import script from "./MaleTutorial.vue?vue&type=script&lang=js"
export * from "./MaleTutorial.vue?vue&type=script&lang=js"
import style0 from "./MaleTutorial.vue?vue&type=style&index=0&id=3bb2bfa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb2bfa7",
  null
  
)

export default component.exports